import React, { useState, useEffect } from "react";
import LoadingWrapper from "components/LoadingWrapper";
import PlatformWrap from "components/PlatformWrap";
import ExamListPagePC from "./platforms/PC";
import ExamListPageMobile from "./platforms/Mobile";
import useRequest from "Utils/useRequest";
import { getExamList, getCurrentTime } from "API";

import style from "./style.module.scss";
import { Modal } from "antd";
import useDeviceType from "../../../Utils/useDeviceType";
import WebCamDetect from "./components/WebCamDetect";
import { getName } from "../../../API";

const PageExamList: React.FC = () => {
    let [examList, { loading: listLoading }, refreshData] = useRequest(() =>
        getExamList()
    );
    const [currentTime, { loading: timeLoading }, loadCurrentTime] = useRequest(
        () => getCurrentTime()
    );
    const [visible, setVisible] = useState(false);
    const { isPC } = useDeviceType();

    useEffect(() => {
        const timeout = setInterval(() => {
            loadCurrentTime();
        }, 5000);

        return () => clearInterval(timeout);
    }, []);

    useEffect(() => {
        getName();
    }, []);
    return (
        <div>
            <LoadingWrapper isEmpty={false} loading={listLoading}>
                {() => (
                    <PlatformWrap
                        mobile={
                            <ExamListPageMobile
                                refreshData={refreshData}
                                currentTime={currentTime?.dateTime!}
                                examList={examList || []}
                                onTipClick={() => setVisible(true)}
                            />
                        }
                        pc={
                            <ExamListPagePC
                                currentTime={currentTime?.dateTime!}
                                examList={examList || []}
                                onTipClick={() => setVisible(true)}
                            />
                        }
                    />
                )}
            </LoadingWrapper>

            <Modal
                title="考试注意事项"
                visible={visible}
                width={isPC ? 1000 : undefined}
                onCancel={() => setVisible(false)}
                footer={null}
                className={style.modal}
                destroyOnClose>
                <p style={{ color: "red" }}>
                    为了保证考试顺利进行，请学生们提前确认以下各事项是否符合要求，如果不符合请尽快更换以免影响作答。
                </p>

                <p>一、考前准备</p>
                <ul>
                    <li>
                        账号信息：请确定当前登录白果云学生端的账号信息准确无误。
                    </li>
                    <li>
                        硬件设备：带有可用摄像头的笔记本或台式电脑（禁止使用手机、ipad等设备），如果当前页面的摄像头检测显示“检测到摄像头无法正常工作”，请及时更换摄像头或电脑。
                    </li>
                </ul>

                <WebCamDetect />

                <ul>
                    <li>
                        软件要求：Chrome谷歌浏览器（Chrome浏览器官网下载链接：
                        <a
                            href="https://www.google.cn/intl/zh-CN/chrome"
                            target="_blank"
                            rel="noreferrer">
                            https://www.google.cn/intl/zh-CN/chrome
                        </a>
                        ）
                    </li>
                    <li>网络环境：可以访问互联网，且网络畅通</li>
                </ul>

                <p>二、考试过程须知</p>

                <ul>
                    <li>
                        线上考试”类的考核，开考30分钟内禁止交卷，考试结束前15分钟系统会提示学生尽快作答。
                    </li>
                    <li>
                        考生作答过程中，如果出现输入的作答内容或上传的附件不能及时显示，建议刷新界面后确认内容及附件是否正常显示，如果依然不显示请重新输入或重新上传。
                    </li>
                    <li>
                        考生作答过程中，如果界面提示“您的作答内容正在保存中，请稍后继续作答，如果持续出现此类错误请刷新界面”，建议考生刷新界面后再次尝试。
                    </li>
                    <li>
                        考生作答过程中，如过因断网、网络故障等原因造成网络中断，请先退出白果云平台，然后重新登录白果进入考试界面继续作答。
                    </li>
                    <li>
                        请考生在作答前仔细阅读答题要求，并按照要求作答。提交考试前请先刷新界面，然后确认试题是否均已作答，最后再提交试卷。提交试卷后无法再次打开试卷，请考生谨慎提交。
                    </li>
                </ul>

                <p>三、其他事项</p>

                <ul>
                    <li>禁止多设备同时登录。</li>
                    <li>
                        如您未使用过白果云，请点击导航栏的“帮助中心”查看白果云考试的使用说明。
                    </li>
                </ul>
            </Modal>
        </div>
    );
};

export default PageExamList;
